import PropTypes from 'prop-types';
import { action, extendObservable } from 'mobx';
import { PolicyModalSectionProps } from '../PolicyModalStore';
import RadioButtonStore from '../../RadioButtonStore';

const DEFAULT_VALUES = {
    action: 'BLOCK',
};

export default class FileRuleActionStore {
    static PropType = PropTypes.shape({
        allowUploadsDownloads: PropTypes.bool,
        action: RadioButtonStore.PropType.isRequired,

        ...PolicyModalSectionProps,
    });

    constructor(data = {}) {
        extendObservable(this, /** @class FileRuleActionStore */{
            action: new RadioButtonStore(),
            allowUploadsDownloads: false,

            originalValue: {},
        }, data);
    }

    setAllowUploadDownload(allowUploadsDownloads) {
        this.allowUploadsDownloads = allowUploadsDownloads;
    }

    setValue = action((value) => {
        value = { ...DEFAULT_VALUES, ...value };
        this.originalValue = value;
        this.action.setValue(value.action);
    });

    isEmpty = () => !this.action.value;

    getValue = () => ({ action: this.action.value });

    hasChanged = () => this.action.value !== this.originalValue.action;

    isValid = () => !!this.action.value
        && (this.allowUploadsDownloads || !['ALLOW', 'SCAN'].includes(this.action.value));
}
